import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["view", "edit"];

  connect() {
    this.mode = this.element.getAttribute("data-mode");
    this.startedOnEditMode = (this.mode == "edit");

    // Listen to keyboard "esc" key press
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.mode === "edit" && !this.startedOnEditMode) {
        this.cancel();
      }
    });
  }

  edit() {
    this.viewTarget.classList.add("hidden");
    this.editTarget.classList.remove("hidden");
    this.mode = "edit";
  }

  cancel() {
    this.viewTarget.classList.remove("hidden");
    this.editTarget.classList.add("hidden");
    this.mode = "view";
    // If there are any errors, clear them.
    this.editTarget.querySelectorAll("[data-error]").forEach((error) => error.innerHTML = "");
  }
}